module.exports = __webpack_public_path__ + "static/media/dm.0f7c685d.webp";